var map = {
	"./ar/translation.json": 2785,
	"./de/translation.json": 2786,
	"./el/translation.json": 2787,
	"./en/translation.json": 2788,
	"./es/translation.json": 2789,
	"./fil/translation.json": 2790,
	"./fr/translation.json": 2791,
	"./hi/translation.json": 2792,
	"./id/translation.json": 2793,
	"./it/translation.json": 2794,
	"./ko/translation.json": 2795,
	"./ms/translation.json": 2796,
	"./nl/translation.json": 2797,
	"./pl/translation.json": 2798,
	"./pt-BR/translation.json": 2799,
	"./pt-PT/translation.json": 2800,
	"./ru/translation.json": 2801,
	"./se/translation.json": 2802,
	"./tr/translation.json": 2803,
	"./uk/translation.json": 2804,
	"./zh/translation.json": 2805
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2784;